/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import axios from 'axios';
// import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';
import { MotionContainer } from '../../components/MotionContainer';
import { useDashboards } from '../../contexts/DashboardContext';
import { Loading } from '../../components/Loading';

export function DashboardPage({ history }) {
  const { setPaths } = useBreadcrumb();
  const intl = useIntl();
  const { id } = useParams();
  const { dashboards } = useDashboards();
  // const { user } = useSelector((state) => state.auth)

  useEffect(() => {
    async function getData() {
      embedDashboard({
        id, // given by the Superset embedding UI
        supersetDomain: 'https://analytics-dev.senseworks.ai:443',
        mountPoint: document.getElementById('chart-container'), // any html element that can contain an iframe
        fetchGuestToken: async () => await getSuperSetToken([id]),
        debug: true,
        dashboardUiConfig: {
          // dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional)
          hideTitle: false,
          hideChartControls: false,
          hideTab: false,
          filters: {
            expanded: true,
            visible: true,
          },
        },
      });
    }
    if (id) getData();
  }, [id]);

  useEffect(() => {
    const dashboardName = dashboards.find(x => x.embeddedId === id)
      ?.dashboard_title;
    setPaths([
      {
        title: intl.formatMessage({ id: 'MENU.DASHBOARD' }),
        pathname: `/dashboard`,
      },
      id ? { title: dashboardName, pathname: `/dashboard/${id}` } : {},
    ]);
  }, [dashboards, id]);

  useEffect(() => {
    // Skip redirect if dashboard loading is disabled in local mode
    if (import.meta.env.VITE_SKIP_DASHBOARD_LOAD === 'true') {
      return;
    }
    if (!id && dashboards.length) {
      history.push(`/dashboard/${dashboards[0].embeddedId}`);
    }
  }, [dashboards]);

  const getSuperSetToken = async dashboards => {
    const { data } = await axios.post('/dashboards/tokens', {
      dashboards,
    });
    return data.token;
  };

  return (
    <MotionContainer className="card h-100 d-flex flex-center">
      {import.meta.env.VITE_SKIP_DASHBOARD_LOAD === 'true' ? (
        <div className="d-flex flex-column align-items-center justify-content-center">
          <h4 className="text-muted mb-3">Dashboard Loading Disabled</h4>
          <p className="text-muted">
            Dashboard loading is skipped in local development mode.
          </p>
          <p className="text-muted">
            Remove <code>VITE_SKIP_DASHBOARD_LOAD</code> from your{' '}
            <code>.env.local</code> to enable dashboards.
          </p>
        </div>
      ) : (
        <>
          <Loading isLoading={!id && !dashboards.length} />
          <div id="chart-container" className="w-100 h-100"></div>
        </>
      )}
    </MotionContainer>
  );
}

// import { generateChart } from '../../utils/charts/hierarchy'
// const [areasPromise, facilitiesPromise, floorPlansPromise, zonesPromise] = await Promise.all([
//     axios.get('/areas'),
//     axios.get('/facilities'),
//     axios.get('/floor-plans'),
//     axios.get('/zones'),
// ])
// const data = areasPromise.data.map(area => {
//     const areaChildrens = facilitiesPromise.data.filter(facility => facility.areaId === area.id)
//     const children = areaChildrens.map(facility => {
//         const facilityChildrens = floorPlansPromise.data.filter(fp => fp.facilityId === facility.id)
//         let mappedChildrens = facilityChildrens.map(fp => ({ name: fp.name, id: fp.id }))
//         mappedChildrens = mappedChildrens.map(floorPlan => {
//             const floorPlanChildrens = zonesPromise.data.filter(zone => zone.floorPlanId === floorPlan.id)
//             const mappedChildrens = floorPlanChildrens.map(fp => ({ name: fp.name, value: 1 }))
//             return {
//                 name: floorPlan.name,
//                 ...mappedChildrens.length ? { children: mappedChildrens } : { value: 1 },
//             }
//         })
//         return {
//             ...mappedChildrens.length ? { children: mappedChildrens } : { value: 1 },
//             name: facility.name
//         }
//     })
//     return {
//         ...children.length ? { children } : { value: 1 },
//         name: area.name
//     }
// })
// root = generateChart('chart-container', user.entityName, data)
